import React from "react";
import { useSelector } from "react-redux";
import { ODSLoadingSpinner, ODSText } from "@telekom-ods/react-ui-kit";
import classes from "./Loader.module.scss";

const Loader = () => {
	const { open: showLoader, type } = useSelector(
		(state) => state.loader.open
	);

	return (
		showLoader && (
			<div className={classes.overlay}>
				<div className={classes.container}>
					<ODSLoadingSpinner
						labelText="Bitte haben Sie ein wenig Geduld..."
						accessibilityTitle=""
						size="large"
					/>
					{type === "options" && (
						<ODSText
							as="p"
							className="body"
						>
							Wir prüfen gerade Ihre
							E-Mail-Adresse. Sie
							werden gleich
							weitergeleitet.
						</ODSText>
					)}
				</div>
			</div>
		)
	);
};

export default Loader;
